export function OutlineColorIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 7.99679V6H20.0015L18 9.99838V19.3727H15.84"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.09592 5.99999L8.18872 3H12.0047L13.0031 5.99999L14.0015 8.99998"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.39844 16.402L7.20003 17.1988L9.60002 14.7988"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00158 20.9993C10.7639 20.9993 13.0032 18.76 13.0032 15.9977C13.0032 13.2354 10.7639 10.9961 8.00158 10.9961C5.23928 10.9961 3 13.2354 3 15.9977C3 18.76 5.23928 20.9993 8.00158 20.9993Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
